import React, { useState, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import RichTextEditor from "../../../components/RichTextEditor";
import DirectoryApi from "../../../api/directoryApi";
import "../../../assets/css/LsFormModern.css";

interface DirectoryModelProps {
  show: boolean;
  onHide: () => void;
  directory?: any;
  retreatData?: any;
}

const DirectoryModel = ({
  show,
  onHide,
  directory,
  retreatData,
}: DirectoryModelProps) => {
  const [footerText, setFooterText] = useState(directory?.footerText || "");
  const [saving, setSaving] = useState(false);
  const directoryApi = new DirectoryApi();

  useEffect(() => {
    if (show) {
      setFooterText(directory?.footerText || "");
    }
  }, [show, directory]);

  const handleSubmit = async () => {
    if (saving) return;
    setSaving(true);
    try {
      const res: any = await directoryApi.createDirectory({
        headerText: footerText,
        retreatId: directory?.retreatId || retreatData?.id,
        directoryId: directory?.id,
      });
      if (res.success) {
        toast.success(res.msg);
        onHide();
      } else {
        toast.error(res.msg || "Could not save footer text.");
      }
    } catch (error: any) {
      toast.error(
        error?.msg || error?.message || "Could not save footer text.",
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={() => {
        if (!saving) onHide();
      }}
      size="lg"
      aria-labelledby="directory-footer-editor-title"
      centered
      contentClassName="ls-form-modal-content"
    >
      <Modal.Header closeButton={!saving}>
        <div className="dir-footer-editor-heading">
          <Modal.Title id="directory-footer-editor-title">
            Footer text
          </Modal.Title>
          <p className="dir-footer-editor-sub">
            Shown at the bottom of the published directory
          </p>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="dir-footer-editor">
          <RichTextEditor
            editorKey={show ? `footer-${directory?.id || "new"}` : "closed"}
            value={footerText}
            onChange={setFooterText}
            height={320}
            variant="default"
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={saving}>
          Cancel
        </Button>
        <Button
          variant="primary"
          type="button"
          onClick={handleSubmit}
          disabled={saving}
        >
          {saving ? "Saving…" : "Save"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DirectoryModel;
